var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_jobx)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 22 L14 16 L8 10 L10 8 L16 14 L22 8 L24 10 L18 16 L24 22 L22 24 L16 18 L10 24 Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 3,
    height: 0.8,
    rx: 0.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20.5,
    width: 2,
    height: 0.8,
    rx: 0.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22,
    width: 1,
    height: 0.8,
    rx: 0.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 29,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: 4,
    textAnchor: "middle"
  }, "jobX"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_jobx"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6ca9498c99904f967db424ddf2f92248.svg";
export { ForwardRef as ReactComponent };